import _ from 'lodash';
import DisclosureFooter from '~/components/members-area/DisclosureFooter.vue';
export default {
  name: 'PolicyUpdateSection',
  components: {
    DisclosureFooter
  },
  props: {
    policyMetadata: {
      type: Object,
      required: true
    },
    plan: {
      type: Object
    },
    planAutopay: {
      type: Boolean
    },
    extraUser: {
      type: Boolean,
      default: false
    },
    applicationQueued: {
      type: Boolean,
      default: false
    },
    mid: {
      type: Number
    }
  },
  data() {
    return {
      formPolicies: {
        // this needs to be separate from formPolicyConsentTimestamps for v-model to work
        age_check: false,
        e_sign: false,
        ecbsv_authorization: false,
        extra_credit_notice: false,
        military_lending: false
      },
      formPolicyConsentTimestamps: {},
      formProcessing: false,
      firedDirtyFormEvent: false
    };
  },
  computed: {
    formFilled() {
      const userOnlyPolicies = ['extra_credit_notice'];
      const requiredPolicies = _.omit(this.formPolicies, ['military_lending', 'ecbsv_authorization', ...(this.extraUser ? [] : userOnlyPolicies)]);
      return Object.values(requiredPolicies).every(Boolean);
    }
  },
  watch: {
    'formPolicies.military_lending': {
      deep: true,
      handler(after) {
        // val is checked
        if (after === true) {
          // settimeout trick helps set the value in the watcher
          setTimeout(() => {
            // explicit deep setter
            this.$set(this.formPolicies, 'military_lending',
            // value false if the user cancels, true if agrees to the prompt
            window.confirm('Please re-confirm you are covered by the Military Lending Act.\nSelect "Cancel" to de-select this option."'));
            this.policyChange('military_lending');
          }, 1);
        }
      }
    }
  },
  mounted() {
    this.$analyticsHub.identify(this.mid);
    this.$analyticsHub.track('Policy Update Viewed', {});
  },
  methods: {
    fireDirtyFormEvent() {
      if (!this.firedDirtyFormEvent && Object.values(this.formPolicies).includes(true)) {
        this.$analyticsHub.track('Policy Update Started', {});
        this.firedDirtyFormEvent = true;
      }
    },
    showDisclosure(disc) {
      this.$emit('disclosure', disc);
      this.fireDirtyFormEvent();
    },
    policyChange(name) {
      if (this.formPolicies[name]) {
        this.formPolicyConsentTimestamps[name] = new Date();
        this.fireDirtyFormEvent();
      } else {
        this.$delete(this.formPolicyConsentTimestamps, name);
      }
    },
    async submit(event) {
      event.preventDefault();
      this.formProcessing = true;

      // these are inherent when you click Continue
      const submitDate = new Date();
      this.$set(this.formPolicyConsentTimestamps, 'extra_tos', submitDate);
      this.$set(this.formPolicyConsentTimestamps, 'extra_privacy', submitDate);
      try {
        if (this.extraUser && !this.applicationQueued) {
          await this.$axios.post('/api/members/confirm-cardholder', {
            policyTimestamps: this.formPolicyConsentTimestamps,
            policyMetadata: this.policyMetadata,
            plan: this.plan,
            planAutopay: this.planAutopay,
            isPolicyUpdate: true
          });
        } else {
          await this.$axios.post('/api/members/policy-update', {
            policyTimestamps: this.formPolicyConsentTimestamps,
            policyMetadata: this.policyMetadata
          });
        }
      } catch (error) {
        console.error('[PolicyUpdateSection]', error);
        return this.$emit('error', error);
      }
      this.$emit('complete');
      this.$analyticsHub.track('Policy Update Complete', {});
    }
  }
};